module.exports = __webpack_public_path__ + "static/media/data-analyst-main.a95d5f92.svg";